<div #inputWrap class="adminui-autocomplete__field" cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <input #input type="text" class="adminui-autocomplete__input" role="combobox" aria-autocomplete="list"
        autocomplete="off" [value]="inputText()" [placeholder]="placeholder()" [disabled]="disabled()"
        [attr.aria-expanded]="open()" [attr.aria-controls]="open() ? listboxId : null"
        [attr.aria-activedescendant]="activeDescendant()" [attr.aria-label]="ariaLabel() || null"
        [attr.aria-labelledby]="ariaLabelledby() || null" (input)="onInput($event)" (focus)="onInputFocus($event)"
        (blur)="onInputBlur($event)" (keydown)="onKeydown($event)" />
    @if (dropdown()) {
    <button type="button" class="adminui-autocomplete__dropdown" tabindex="-1" [attr.aria-label]="toggleLabel"
        [disabled]="disabled()" (mousedown)="$event.preventDefault()" (click)="onDropdownClick($event)">
        <span class="adminui-autocomplete__chevron" aria-hidden="true"></span>
    </button>
    }
</div>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayOpen]="open() && (rows.length > 0 || !!emptyMessage())"
    [cdkConnectedOverlayMinWidth]="inputWrap.offsetWidth" [cdkConnectedOverlayPush]="true" (detach)="hide()">
    <div class="adminui-autocomplete__panel" role="listbox" [id]="listboxId"
        [attr.aria-label]="ariaLabel() || null" [attr.aria-labelledby]="ariaLabelledby() || null">
        @if (group()) {
        @for (g of displayGroups; track $index) {
        <div role="group" [attr.aria-labelledby]="g.labelId">
            <div class="adminui-autocomplete__group" [id]="g.labelId">
                @if (groupTpl) {
                <ng-container [ngTemplateOutlet]="groupTpl.template"
                    [ngTemplateOutletContext]="{ $implicit: g.group }"></ng-container>
                } @else {
                {{ g.group.label }}
                }
            </div>
            @for (row of g.items; track $index) {
            <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: row.item, index: row.index }"></ng-container>
            }
        </div>
        } @empty {
        <div class="adminui-autocomplete__empty">{{ emptyMessage() }}</div>
        }
        } @else {
        @for (item of suggestions(); track $index) {
        <ng-container *ngTemplateOutlet="optionTpl; context: { $implicit: item, index: $index }"></ng-container>
        } @empty {
        <div class="adminui-autocomplete__empty">{{ emptyMessage() }}</div>
        }
        }
    </div>
</ng-template>

<ng-template #optionTpl let-item let-index="index">
    <!-- A listbox option must NOT be focusable - the input above carries role combobox, owns the
         keyboard through its keydown handler, and points at the active option via
         aria-activedescendant.
         No angle brackets or quoted attributes in this comment on purpose: Sonar's
         Web:AvoidCommentedOutCodeCheck reads those as commented-out code, and it flagged this block.
      -->
    <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus, @angular-eslint/template/click-events-have-key-events -->
    <div class="adminui-autocomplete__option" role="option" [id]="optionId(index)"
        [adminuiTruncationTitle]="labelOf(item)"
        [attr.aria-selected]="isSelected(item)" [class.adminui-autocomplete__option--selected]="isSelected(item)"
        [class.adminui-autocomplete__option--active]="index === activeIndex()"
        (mousedown)="$event.preventDefault()" (click)="selectItem(item, $event)"
        (mouseenter)="activeIndex.set(index)">
        @if (itemTpl) {
        <ng-container [ngTemplateOutlet]="itemTpl.template"
            [ngTemplateOutletContext]="{ $implicit: item }"></ng-container>
        } @else {
        {{ labelOf(item) }}
        }
    </div>
</ng-template>
